var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect } from '@ngrx/effects';
import { Feedback } from '../actions/feedback.actions';
import { OrganisationsApi } from '@careapp/angular-sdk';
import { withLatestFrom, catchError, map, switchMap, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as actions from '../actions';
import * as selectors from '../reducers/index';
import { of } from 'rxjs';
var FeedbackEffects = /** @class */ (function () {
    function FeedbackEffects(actions$, store, api) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.api = api;
        this.listFeedback$ = this.actions$.ofType(Feedback.REQUEST_ALL).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)), this.store.select(selectors.statistics.getFilters)), switchMap(function (_a) {
            var action = _a[0], orgId = _a[1], filters = _a[2];
            return _this.api
                .listFeedback(orgId, {
                where: {
                    created: {
                        between: [filters.dateFrom.toISOString(), filters.dateTo.toISOString()]
                    }
                }
            })
                .pipe(map(function (response) { return Feedback.ResponseSuccessAllAction(response); }), catchError(function (err) { return of(Feedback.ResponseFailAllAction(err)); }));
        }));
        this.fetchRelatedMembers$ = this.actions$.ofType(Feedback.RESPONSE_SUCCESS_ALL).pipe(tap(function (action) {
            action.payload.map(function (stat) {
                _this.store.dispatch(actions.Staff.RequestByIdAction({ id: stat.memberId }));
            });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], FeedbackEffects.prototype, "listFeedback$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], FeedbackEffects.prototype, "fetchRelatedMembers$", void 0);
    return FeedbackEffects;
}());
export { FeedbackEffects };
